import { render, staticRenderFns } from "./OauthAuthorizedApplicationsList.vue?vue&type=template&id=e5c4edce"
import script from "./OauthAuthorizedApplicationsList.vue?vue&type=script&lang=js"
export * from "./OauthAuthorizedApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./OauthAuthorizedApplicationsList.vue?vue&type=style&index=0&id=e5c4edce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports